import { createAction } from '../../utils';
import * as ActionTypes from './actionTypes';

export const updateTranslationsData = createAction(ActionTypes.TRANSLATIONS_DATA_UPDATE);